<h1 class="h3 mb-2 text-gray-800">Contraseña</h1>

<div class="card shadow mb-4">
    <div class="card-header py-3">
        <h6 class="m-0 font-weight-bold text-primary">Actualizar contraseña</h6>
    </div>
    <div class="card-body">
        <div class="row">
            <div class="col-12">
                <form name="form" (ngSubmit)="f.form.valid && guardarDatos()" #f="ngForm">
                    <div class="row">
                        <div class="col-6">
                            <div class="form-group">
                                <label>Contraseña actual</label>
                                <input type="password" class="form-control" name="password"
                                    [(ngModel)]="passwordFields.password" #password="ngModel"
                                    [ngClass]="{'is-invalid':  f.submitted && password.invalid}" required />
                                <div *ngIf="f.submitted && password.invalid" class="invalid-feedback">
                                    <div *ngIf="password.errors.required">El Paciente es requerido</div>
                                </div>
                            </div>
                            <div class="form-group">
                                <label>Nueva contraseña</label>
                                <input type="password" class="form-control" name="newPassword"
                                    [(ngModel)]="passwordFields.newPassword" #newPassword="ngModel" minlength="8"
                                    maxlength="20" [ngClass]="{'is-invalid':  f.submitted && newPassword.invalid}"
                                    required />
                                <div *ngIf="f.submitted && newPassword.invalid" class="invalid-feedback">
                                    <div *ngIf="newPassword.errors.required">Escriba su nueva contraseña</div>
                                </div>
                            </div>
                            <div class="form-group">
                                <label>Confirmar contraseña</label>
                                <input type="password" class="form-control" name="confirmPassword"
                                    [(ngModel)]="passwordFields.confirmPassword" #confirmPassword="ngModel"
                                    [ngClass]="{'is-invalid':  f.submitted && confirmPassword.invalid}" required />
                                <div *ngIf="f.submitted && confirmPassword.invalid" class="invalid-feedback">
                                    <div *ngIf="confirmPassword.errors.required">Debe escribir nuevamente la contraseña
                                    </div>
                                </div>
                                <div class="invalid-feedback"
                                    *ngIf="passwordFields.confirmPassword && passwordFields.newPassword !== passwordFields.confirmPassword && confirmPassword.touched">
                                    Las contraseñas no coinciden
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <div class="form-group">
                                <button type="submit" class="btn btn-primary"
                                    [disabled]="f.invalid || passwordFields.newPassword !== passwordFields.confirmPassword">
                                    Cambiar Contraseña</button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>